import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography, styled } from "@mui/material";
import ButtonBlue from "../../../shared/general/ButtonBlue";
import OrganizationList from "./OrganizationList";
import { useDispatch, useSelector } from "react-redux";
import { getOrganizationChart } from "../../../../../actions/orgChart";
import DialogAddStructure from "./DialogAddStructure";
import { getManager } from "../../../../../actions/manager";
// import organization from "./CEOOffice";
import AddIcon from "@mui/icons-material/Add";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";

import Pic from "../../../assets/-_approval list.png";
import {
  deleteOrganizationStructure,
  getOrganizationStructure,
} from "../../../../../actions/organizationStructure";
import Notification from "../../../shared/general/Notification";
import DialogConfirmDelete from "../../../shared/general/DialogConfirmDelete";
import DialogEditCEO from "./DialogEditCEO";
import { useTranslation } from "react-i18next";
import { OrganizationStructureXlsx } from "./OrganizationStructureXlsx";

const StyledRoot = styled(Box)({
  marginTop: "30px",
});

const OrganizationStructure = () => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();

  const { result: userProfile } = useSelector((state) => state.userProfile);
  const { result: OrganizationStructureData } = useSelector((state) => state.organizationStructure);

  const [drawerConfig, setDrawerConfig] = useState({
    isOpen: false,
    isEdit: false,
    data: null,
  });

  const [drawerCEOConfig, setDrawerCEOConfig] = useState({
    isOpen: false,
    // isEdit: false,
    data: null,
  });

  const [deleteConfig, setDeleteConfig] = useState({
    isOpen: false,
    isEdit: false,
    data: null,
  });

  const [alertConfig, setAlertConfig] = useState({
    isOpen: false,
    type: "success",
    message: "",
  });

  const handleAddStructure = () => {
    setDrawerConfig((prev) => ({
      ...prev,
      isOpen: true,
      isEdit: false,
      data: null,
    }));
  };

  const handleCloseDialog = () => {
    setDrawerConfig((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  const handleCloseDeleteModal = () => {
    setDeleteConfig((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  const handleDelete = async () => {
    const response = await dispatch(
      deleteOrganizationStructure({
        nodeType: deleteConfig.data.nodeType,
        idNode: deleteConfig.data.idNode,
      })
    );

    if (response) {
      if (response.status === 200) {
        setAlertConfig((prev) => ({
          ...prev,
          isOpen: true,
          type: "success",
          message: `${t("DataSaveSuccessful")}`,
        }));
        dispatch(
          getOrganizationStructure({ idCompany: userProfile.idCompany })
        );
        handleCloseDeleteModal();
      } else {
        setAlertConfig((prev) => ({
          ...prev,
          isOpen: true,
          type: "error",
          message: `${t("AnErrorOccurred")} ${t("ContactAdmin")}`,
        }));
      }
    } else {
      setAlertConfig((prev) => ({
        ...prev,
        isOpen: true,
        type: "error",
        message: `${t("AnErrorOccurred")} ${t("ContactAdmin")}`,
      }));
    }

    setDeleteConfig((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  useEffect(() => {
    if (userProfile) {
      // dispatch(getManager({ idCompany: userProfile.idCompany }));
      dispatch(
        getOrganizationStructure({ idCompany: userProfile.idCompany })
      );
    }
  }, [userProfile]);

  const handleXlsxExport = () => {
    if (OrganizationStructureData) {
      OrganizationStructureXlsx(OrganizationStructureData);
    } else {
      return;
    }
  };

  return (
    <StyledRoot>
      <Box marginBottom="16px">
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography fontSize="1.5rem" fontWeight="500">
              {t("ManageOrganizationalStructure")}
            </Typography>
          </Grid>
          <Grid item>
            <ButtonBlue
              variant={"contained"}
              startIcon={<DownloadRoundedIcon />}
              onClick={() => handleXlsxExport()} 
              style={{ marginRight: "12px" }}
            >
              {t("DownloadData")}
            </ButtonBlue>
            <ButtonBlue
              variant={"contained"}
              startIcon={<AddIcon />}
              onClick={handleAddStructure}
            >
              {t("AddNewOganization")}
            </ButtonBlue>
          </Grid>
        </Grid>
      </Box>

      <Box marginTop="24px">
        <OrganizationList
          title="CEO Office"
          setDrawerConfig={setDrawerCEOConfig}
          data={OrganizationStructureData ? OrganizationStructureData.ceos : []}
          setDeleteConfig={setDeleteConfig}
        />
      </Box>
      <Box marginTop="24px">
        <OrganizationList
          title="Business Unit"
          setDrawerConfig={setDrawerConfig}
          data={
            OrganizationStructureData
              ? OrganizationStructureData.businessUnits
              : []
          }
          setDeleteConfig={setDeleteConfig}
        />
      </Box>
      <Box marginTop="24px">
        <OrganizationList
          title="Division"
          setDrawerConfig={setDrawerConfig}
          data={
            OrganizationStructureData ? OrganizationStructureData.divisions : []
          }
          setDeleteConfig={setDeleteConfig}
        />
      </Box>
      <Box marginTop="24px">
        <OrganizationList
          title="Department"
          setDrawerConfig={setDrawerConfig}
          data={
            OrganizationStructureData
              ? OrganizationStructureData.departments
              : []
          }
          setDeleteConfig={setDeleteConfig}
        />
      </Box>
      <Box marginTop="24px">
        <OrganizationList
          title="Section"
          setDrawerConfig={setDrawerConfig}
          data={
            OrganizationStructureData ? OrganizationStructureData.sections : []
          }
          setDeleteConfig={setDeleteConfig}
        />
      </Box>

      <DialogAddStructure
        drawerConfig={drawerConfig}
        onClose={handleCloseDialog}
        data={OrganizationStructureData ? OrganizationStructureData : []}
        setAlertConfig={setAlertConfig}
      />

      <DialogEditCEO
        drawerConfig={drawerCEOConfig}
        onClose={() => {
          setDrawerCEOConfig((prev) => ({
            ...prev,
            isOpen: false,
          }));
        }}
        setAlertConfig={setAlertConfig}
      />

      <DialogConfirmDelete
        open={deleteConfig.isOpen}
        handleClose={handleCloseDeleteModal}
        label={deleteConfig.data ? deleteConfig.data.label : ""}
        text={deleteConfig.data ? deleteConfig.data.text : ""}
        handleDelete={handleDelete}
      />

      <Notification notify={alertConfig} setNotify={setAlertConfig} />
    </StyledRoot>
  );
};

export default OrganizationStructure;
